import React from "react";
import * as T from "./types";
import * as S from "./styles";

const Slider: React.FC<T.IProps> = (props) => {

  const BAR_WIDTH = props.barWidth ?? 84;
  const BAR_HEIGHT = props.barHeight ?? 1;
  const DIAMETER = props.sphereRadius ? props.sphereRadius * 2 : 8; 
  const COLOR = props.color ?? "#2b3a66";

  const [spherePos, setSpherePos] = React.useState(props.value);
  const [grabbing, setGrabbing] = React.useState(false);

  const handleSave = () => {
    setGrabbing(false);
    props.handleValue(props.id, spherePos);
  }

  const handleMouseMove = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (grabbing && !props.disabled) {
      const diff = parseInt(e.target.value);
      setSpherePos(diff);
      if (props.onChange) props.onChange(props.id, diff);
    }
  }

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    setGrabbing(true);
  }

  const handleMouseUp = (e: React.MouseEvent<HTMLDivElement>) => {
    handleSave();
  }

  React.useEffect(() => {
    if (props.value !== null && props.value !== spherePos) setSpherePos(props.value);
  }, [props.value])

  return (
    <S.Root style={props.style} >
      {
        props.title !== undefined &&
        <S.Label>
          {props.title}
        </S.Label>
      }
      <S.SliderContainer
        id={props.id}
        widthValue={BAR_WIDTH}
        onMouseUp={handleMouseUp}
      >
        <S.Sphere
          id={`${props.disabled ? 'disabled' : 'enabled'}-slider-control`}
          heightValue={BAR_HEIGHT}
          value={spherePos}
          cursorValue={props.disabled ? undefined : grabbing ? `grabbing` : `grab`}
          isDisabled={props.disabled}
          colorValue={props.disabled ? undefined : COLOR}
          diameterValue={DIAMETER}
          type="range"
          min={props.minValue}
          max={props.maxValue}
          onMouseDown={handleMouseDown}
          onChange={handleMouseMove}
        />
        {
          (!props.disabled && props.tip) &&
          <S.Seconds
            leftValue={(spherePos - props.minValue) * BAR_WIDTH / (props.maxValue - props.minValue) - 16}
            colorValue={props.disabled ? undefined : COLOR}
          >
            {`${spherePos} ${props.tip}`}
          </S.Seconds>
        }
      </S.SliderContainer>
    </S.Root>
  );
}

export default Slider;
